import { Injector } from '@angular/core';
import { MEMBERSHIP_PLUGINS_TOKEN, MembershipPluginsService } from '@common/membership/shared';
import { ConfigService } from '@core/frontend-shared';
import { sharedInjectorForFrontend } from '@core/frontend-shared/providers';
import { FeatureProvidersRegistry } from '@core/shared/feature';
import * as i0 from "@angular/core";
import * as i1 from "@core/frontend-shared";
import * as i2 from "@core/shared/feature";
export let FrontendMembershipPluginsService = /*#__PURE__*/(() => {
  class FrontendMembershipPluginsService extends MembershipPluginsService {
    constructor(config, injector, featureProvidersRegistry) {
      super(config, sharedInjectorForFrontend(injector), featureProvidersRegistry.getProviders(MEMBERSHIP_PLUGINS_TOKEN));
    }
    ngOnInit() {
      console.info('>>>> ngOnInit');
      return this.initialize();
    }
    static {
      this.ɵfac = function FrontendMembershipPluginsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FrontendMembershipPluginsService)(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i2.FeatureProvidersRegistry));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: FrontendMembershipPluginsService,
        factory: FrontendMembershipPluginsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FrontendMembershipPluginsService;
})();